module.exports = __webpack_public_path__ + "static/media/Gen Doc.3c7fc240.odt";